import React, { Component } from "react"
import { Row, Col, Grid } from "react-bootstrap"
import history from "../../../history"

import { withCookies } from "react-cookie"

import Avatar from "react-avatar"

import "./HSGNavigation.css"

import iconDashboard from "./icons/dashboard.svg"
import iconMedicalHistory from "./icons/medical-history.svg"
import iconMyCovidDeclaration from "./icons/covid-declaration.svg"
import iconResources from "./icons/icon-resources.svg"
import iconLiveStats from "./icons/icon-live-stats.svg"
import iconSupport from "./icons/icon-support.svg"

import iconMyCovidDeclarationSelected from "./icons/icon-dashboard-selected.svg"
import iconDashboardSelected from "./icons/dashboard-selected.svg"
import iconResourcesSelected from "./icons/icon-resources-selected.svg"
import iconLiveStatsSelected from "./icons/icon-live-stats-selected.svg"
import iconSupportSelected from "./icons/icon-support-selected.svg"

import iconHSGLogo from "./icons/icon-hsg-logo.svg"
import Constants from "../../../Phi/Constants"
import { withRouter } from "react-router"

const PARENT_TAB_LIST = [
    {
        key: "covid-declaration",
        label: "COVID DECLARATION",
        icon: iconDashboard,
        iconSelected: iconDashboardSelected,
    },
    {
        key: "my-declaration",
        label: "HISTORY",
        icon: iconMyCovidDeclaration,
        iconSelected: iconMyCovidDeclarationSelected,
    },
    {
        key: "covid-stats",
        label: "LIVE UPDATE",
        icon: iconLiveStats,
        iconSelected: iconLiveStatsSelected,
    },
    {
        key: "resources",
        label: "RESOURCES",
        icon: iconResources,
        iconSelected: iconResourcesSelected,
    },
    // {
    //     'key': 'dashboard',
    //     'label': 'DASHBOARD',
    //     'icon': iconDashboard
    // },
    // {
    //     'key': 'medical-history',
    //     'label': 'MEDICAL HISTORY',
    //     'icon': iconMedicalHistory
    // }
]

const OTHER_TAB_LIST = [
    {
        key: "support",
        label: "SUPPORT",
        icon: iconSupport,
        iconSelected: iconSupportSelected,
    },
]

const STUDENT_ASSESSMENT_REPORT_LIST = [
    {
        key: "growth-assessment",
        label: "GROWTH ASSESSMENT",
        iconColor: "#4CD964",
    },
    {
        key: "physical-assessment",
        label: "PHYSICAL ASSESSMENT",
        iconColor: "#EF343B",
    },
    {
        key: "ent-assessment",
        label: "ENT ASSESSMENT",
        iconColor: "#FFAC22",
    },
    {
        key: "eye-assessment",
        label: "EYE ASSESSMENT",
        iconColor: "#5BB8FF",
    },
    {
        key: "dental-assessment",
        label: "DENTAL ASSESSMENT",
        iconColor: "#6F85FF",
    },
]

const STRING_REPORT_GROUP_HEAD = "REPORTS"
const STRING_FOOT_NOTES_POWERED = "Powered by HealthSetGo"
const STRING_FOOT_NOTES_RESERVED = "All rights reserved"

const STRING_BUTTON_LOGOUT = "LOGOUT"

class HSGNavigation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentTab: PARENT_TAB_LIST[0].key,
        }
    }

    componentDidMount() {}

    componentWillReceiveProps(newProps) {
        if (this.props.currentAppLocation !== newProps.currentAppLocation) {
            this.setState({ currentTab: newProps.currentAppLocation.split("#")[0] })
        }
    }

    componentWillUnmount() {}

    // menuMainElements=(index, icon, label, key)=>(
    //     <div className="hsg-navigation-menu" key={index}>
    //         <img className="hsg-navigation-icons" aria-hidden="true" src={icon} />
    //         <span className="hsg-navigation-units" onClick={()=>history.push(key)}>{label}</span>
    //     </div>
    // )

    onClickLogout() {
        const cookies = this.props.cookies
        cookies.remove("token", { path: "/" })
        cookies.remove("roles", { path: "/" })

        this.props.logoutUser()
        window.location.reload(false)
    }

    changeRoute = (key) => {
        this.props.changeLocation(key);
        this.props.unsetSidebarHandler(false);
        var e = document.getElementsByClassName('hamburger__Container')[0].classList.remove('change');
    }

    menuMainElements = (index, icon, label, key, iconSelected) => {
        let isSelected = this.props.location.pathname.split('/')[1] === key
        return (
            <div className={`hsg-navigation-menu ${isSelected ? "hsg-navigation-menu-selected" : ""}`} key={index}>
                <img className="hsg-navigation-icons" aria-hidden="true" src={isSelected ? iconSelected : icon} />
                <div
                    className={`hsg-navigation-units ${isSelected ? "hsg-navigation-units-selected" : ""}`}
                    onClick={() => {
                        // history.push(key);
                        // this.setState({ currentTab: key });
                        this.changeRoute(key)
                    }}
                >
                    {label}
                </div>
            </div>
        )
    }

    menuReportElements = (index, icon, label) => (
        <div className="hsg-navigation-report-menu" key={index}>
            <img className="hsg-navigation-report-icons" style={{ backgroundColor: icon }} aria-hidden="true" src="" />
            <span className="hsg-navigation-report-units padding-10">{label}</span>
        </div>
    )

    navigationFooter = () => (
        <div className="hsg-navigation-footer-group">
            <div>
                <img className="hsg-navigation-own-logo" aria-hidden="true" src={iconHSGLogo} />
            </div>
            <div>
                <div className="hsg-navigation-foot-notes">{STRING_FOOT_NOTES_POWERED}</div>
                <div className="hsg-navigation-foot-notes">{STRING_FOOT_NOTES_RESERVED}</div>
            </div>
        </div>
    )

    navigationReportButtons = () => (
        <div className="padding-left-right-10">
            <button
                className="hsg-btn hsg-navigation-download-overall-btn"
                onClick={() => {
                    this.onClickLogout()
                }}
            >
                <i className="fa fa-sign-out" aria-hidden="true"></i>
                {STRING_BUTTON_LOGOUT}
            </button>
        </div>
    )

    currentChildHead = () => {
        const { childList, childCurrent, user } = this.props

        let possibleName, possibleImage

        if (childList && childList[childCurrent]) {
            const child = childList[childCurrent] || {}
            const isParentAcc = child && child.role ? [Constants.roleIdMap.TEACHER, Constants.roleIdMap.NON_TEACHING].includes(child.role) : false

            if (isParentAcc && user) {
                possibleName = user.fullName
                possibleImage = user.profilePic
            } else {
                possibleName = child.name
                possibleImage = null
            }
        } else if (user) {
            possibleName = user.fullName
            possibleImage = user.profilePic
        }

        return (
            <div className="hsg-navigation-child-user-image">
                <Avatar round={true} size={50} name={possibleName} src={Constants.formatProfilePicURL(possibleImage)} />
                <div className="hsg-navigation-child-info-content">{possibleName}</div>
            </div>
        )
    }

    render() {
        return (
            <section ref="navigation" className="hsg-navigation-root col-md-3 col-lg-2">
                <div ref="parent-tab-list" className="hsg-navigation-parent-tab-list">
                    {/* <div className="hsg-navigation-logo-group"></div> */}
                    <div className="hsg-navigation-child-info-group">{this.currentChildHead()}</div>

                    <hr className="hsg-navigation-division" />

                    <div>
                        {PARENT_TAB_LIST.map((element, index) => this.menuMainElements(index, element.icon, element.label, element.key, element.iconSelected))}
                    </div>

                    <hr className="hsg-navigation-division" />

                    <div>
                        {OTHER_TAB_LIST.map((element, index) => this.menuMainElements(index, element.icon, element.label, element.key, element.iconSelected))}
                    </div>

                    {/* <div>
                        <hr className="hsg-navigation-division" />
                        <div className="margin-bottom-20">
                            <div className="hsg-navigation-menu-low-margin"> 
                                <img className="hsg-navigation-icons" aria-hidden="true" src={iconDashboard} />
                                {
                                    <span className="hsg-navigation-units">{STRING_REPORT_GROUP_HEAD}</span>
                                }
                            </div> 
                        </div>

                        <div className="">
                            {
                                STUDENT_ASSESSMENT_REPORT_LIST.map((element, index) => (
                                    this.menuReportElements(index, element.iconColor, element.label, element.key)                               
                                ))
                            }  
                        </div>

                        <div className="margin-top-50">
                            <div className="hsg-navigation-foot-notes">{STRING_FOOT_NOTES_POWERED}</div>
                            <div className="hsg-navigation-foot-notes">{STRING_FOOT_NOTES_RESERVED}</div>
                        </div>
                    </div> */}

                    {/* <div style={{height: 310}}></div> */}
                    {/* <div className="margin-top-50 padding-right-30">{this.navigationReportButtons()}</div> */}

                    <div className="margin-top-50">{this.navigationFooter()}</div>
                </div>
            </section>
        )
    }
}

export default withCookies(withRouter(HSGNavigation))
